module.exports = __webpack_public_path__ + "img/no_history.76392e8b.png";